
import { Options, Vue } from "vue-class-component";
import { Icon } from 'vant';

@Options({
  components: {
    [Icon.name]: Icon
  },
})
export default class Home extends Vue {
  username = window.localStorage.getItem('username') || '';
  urlList = {
    order: "https://app.mezolen.com/admin/business/contractsalesview/",
    purchase: "https://app.mezolen.com/admin/business/contractpurchaserview/",
    transport: "https://app.mezolen.com/admin/business/contractexpressview/",
    finance: "https://app.mezolen.com/admin/business/contractfinanceview/",
    production: "https://app.mezolen.com/admin/business/contractpqaview/",
    managerSearch: "https://app.mezolen.com/admin/business/contractmanagerview/",
    afterSales: "https://app.mezolen.com/admin/business/contractaftersalesview/",
    dispatch: "https://app.mezolen.com/admin/business/contractdispatchview/",
    visitRecord: "https://app.mezolen.com/admin/business/visitrecord/",
    afterSalesCheckIn: "https://app.mezolen.com/attendance_home/",
    bidSecurity: "https://app.mezolen.com/admin/business/bidsecurity/",
    performanceSecurity: "https://app.mezolen.com/admin/business/performancesecurity/"
  };
  rightPostion = '124px'
  bjcgCount = ''
  cwglCount = ''
  scjcCount = ''
  jcCount = ''
  jlcxCount = ''
  htddCount = ''
  dispatchCount=''
  afterSalesCount=''
  mounted(): void {
    const right = this.$refs['rightStep'] as HTMLAreaElement
    const center = this.$refs['centerStep'] as HTMLAreaElement
    this.rightPostion = `${(right.getBoundingClientRect().left - center.getBoundingClientRect().right)/2 + 100}px`
    this.bjcgCount = window.localStorage.getItem('bjcgCount') || ''
    this.cwglCount = window.localStorage.getItem('cwglCount') || ''
    this.scjcCount = window.localStorage.getItem('scjcCount') || ''
    this.jcCount = window.localStorage.getItem('jcCount') || ''
    this.jlcxCount = window.localStorage.getItem('jlcxCount') || ''
    this.htddCount = window.localStorage.getItem('htddCount') || ''
    this.dispatchCount = window.localStorage.getItem('dispatchCount') || ''
    this.afterSalesCount = window.localStorage.getItem('afterSalesCount') || ''
  }
  navTo(url: string): void {
    window.open(url, '_self')
  }
  logout() {
    // 清除本地存储
    window.localStorage.removeItem('username');
    // 跳转到登录页
    this.$router.push("/");
  }
}
